<template>
  <div v-loading="isBusy">
    <TableDeduction
        :deduction-list="deductionList"
        :lesson="lesson"
        @get-list-deduction="getDeduction"
    />
  </div>
</template>

<script>
import { GET_DEDUCTION_BY_CLASSROOM } from "@/core/services/store/course/classes.module";
import TableDeduction from "@/view/pages/classes/components/TableDeduction.vue";

export default {
  components: {TableDeduction},
  props: {
    lesson: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    return {
      isBusy: false,
      deductionSelected: null,
      isConfirmDelete: false,
      deductionList: [],
      isDelete: false,
      loading: false,
    }
  },
  mounted() {
    this.getDeduction()
  },
  methods: {
    getDeduction() {
      this.isBusy = true
      const payload = {
        classroom_id: this.lesson.classroom_id,
        schedule_id: this.lesson.id,
      }
      this.$store.dispatch(GET_DEDUCTION_BY_CLASSROOM, payload).then(res => {
        if (!res.error) {
          this.deductionList = res.data
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => this.isBusy = false)
    },
  }
}
</script>